<form
  class="dynamic-form flex flex-col gap-5"
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
>
  <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
    @for (field of fields(); track $index) {
      @if(isFieldVisible(field)) {
      
      <div [ngClass]="
      {
        'md:col-span-2': field.colSpan === 2,
        'md:col-span-1': field.colSpan === 1 || field.colSpan === undefined,
      }">
        @if (field.type !== 'checkbox') {
          <label
            class="flex gap-1"
            [for]="field.key">
            <span>{{ field.label }}</span>
            @if(field.required) {
              <span
                class="required text-red-500 text-xl"
                aria-hidden="true"
              >*</span>
            }
            
          </label>
        }
        @switch (field.type) {
          @case ('checkbox') {
            <label class="flex items-center gap-3 cursor-pointer mt-1" [for]="field.key">
              <input
                type="checkbox"
                [id]="field.key"
                [formControlName]="field.key"
                class="
                  w-5 h-5 rounded border-gray-400 text-secondary focus:ring-secondary 
                  transition-all duration-200 cursor-pointer shrink-0
                "
              />
              <span class="text-text-body font-medium select-none">
                {{ field.label }}
                @if(field.required) {
                  <span class="text-red-500 text-xl">*</span>
                }
              </span>
            </label>
          }
          @case ('text') {
            <input
              type="text"
              [id]="field.key"
              [formControlName]="field.key"
              [required]="field.required || false"
              [maxlength]="field.maxLength || null"
              [minlength]="field.minLength || null"
            />
          }
          @case ('textarea') {
            <textarea
              [id]="field.key"
              [formControlName]="field.key"
              [required]="field.required || false"
              [rows]="field.rows || 3"
              class="h-auto!"
              [maxlength]="field.maxLength || null"
              [minlength]="field.minLength || null"
            ></textarea>
          }
          @case ('number') {
            <input
              type="number"
              [id]="field.key"
              [formControlName]="field.key"
              [required]="field.required || false"
              [min]="field.min || null"
              [max]="field.max || null"
            />
          }
          @case ('email') {
            <input
              type="email"
              [pattern]="'[^\\s@]+@[^\\s@]+\\.[^\\s@]+'"
              [id]="field.key"
              [formControlName]="field.key"
              [required]="field.required || false"
            />
          }
          @case ('password') {
            <input
              type="password"
              [id]="field.key"
              [formControlName]="field.key"
              [required]="field.required || false"
            />
          }
          @case ('select') {
            <select
              [id]="field.key"
              [formControlName]="field.key"
              [required]="field.required || false"
              class="custom-select"
            >
              @for (option of field.options; track $index) {
                <option [value]="option.value">{{ option.label }}</option>
              }
            </select>
          }
          @case ('wysiwyg') {
            <div class="w-full">
            <quill-editor
              [id]="field.key"
              [formControlName]="field.key"
              [required]="field.required || false"
              [placeholder]="''"
              [maxLength]="field.maxLength || undefined"
              [minLength]="field.minLength || undefined"
              rows="3"
              class="custom-quill-editor w-full max-h-[200px] overflow-y-auto!"              
            ></quill-editor>
            </div>
          }
          @case ('radio') {
            <div class="w-full flex gap-3 flex-col md:flex-row">
              @for (option of field.options; track $index) {
                <label 
                class="flex items-center gap-3 p-0 md:p-3 cursor-pointer" 
                [for]="`${field.key}-${option.value}`"
                >
                  <input
                    type="radio"
                    [id]="`${field.key}-${option.value}`"
                    [formControlName]="field.key"
                    [value]="option.value"
                    [required]="field.required || false"                   
                    class="
                    appearance-none! w-4! h-4! border-[1.5px]!
                    border-gray-400! rounded-full! 
                    bg-white! checked:border-secondary! 
                     checked:border-[3px]! transition-all duration-200 cursor-pointer shrink-0"
                  />
                  <span class="text-text-body font-heading font-medium select-none">{{ option.label }}</span>
                </label>
              }
            </div>
          }
          @case ('multiselect') {
            <!-- Multiselect with chips inside input -->
            <div class="multiselect-container">
              <!-- Combined input with chips inside -->
              <div class="multiselect-input-wrapper" (click)="focusSearchInput(field.key)">
                <!-- Selected chips inside -->
                @for (chip of selectedChips()[field.key] || []; track chip.value) {
                  <div class="chip">
                    <span class="chip-label">{{ chip.label }}</span>
                    <button
                      type="button"
                      class="chip-remove"
                      (click)="removeChip(field.key, chip.value); $event.stopPropagation()"
                      aria-label="Remove {{ chip.label }}"
                    >
                      <i class="fas fa-times"></i>
                    </button>
                  </div>
                }
                
                <!-- Search input -->
                <input
                  type="text"
                  [id]="field.key"
                  class="multiselect-search-inline"
                  [placeholder]="(selectedChips()[field.key]?.length || 0) === 0 ? (field.placeholder || 'Buscar o agregar...') : ''"
                  [value]="searchQuery()[field.key] || ''"
                  (input)="onMultiselectSearch(field.key, $event)"
                  (focus)="showDropdownFor(field.key)"
                />
              </div>
              
              <!-- Dropdown with options -->
              @if (showDropdown()[field.key]) {
                <div class="multiselect-dropdown">
                  @if (getFilteredOptions(field).length > 0) {
                    @for (option of getFilteredOptions(field); track option.value) {
                      <div
                        class="dropdown-option"
                        (click)="selectOption(field.key, option)"
                      >
                        {{ option.label }}
                      </div>
                    }
                  } 
                  <!-- @else if (searchQuery()[field.key]) {
                    <div
                      class="dropdown-option create-new"
                      (click)="createNewOption(field.key)"
                    >
                      <i class="fas fa-plus"></i>
                      Crear "{{ searchQuery()[field.key] }}"
                    </div>
                  } -->
                   @else {
                    <div class="dropdown-option disabled">
                      No hay opciones disponibles
                    </div>
                  }
                </div>
              }
            </div>
          }
          @case ('file') {
            <!-- File upload with preview -->
            <div class="file-upload-container">
              @if (!getFilePreview(field.key)) {
                <label [for]="field.key" class="file-upload-area">
                  <i class="fas fa-cloud-upload-alt upload-icon"></i>
                  <span class="upload-text">Click para seleccionar imagen</span>
                  <span class="upload-hint">o arrastra y suelta aquí</span>
                  <span class="upload-hint">Extensiones soportadas: {{ field.accept  || '.JPG, .JPEG, .PNG, .GIF' }}</span>
                  @if(field.maxDimensions) {
                    <span class="upload-hint">Dimensión máxima: {{ field.maxDimensions }}</span>
                  }
                  <input
                    type="file"
                    [id]="field.key"
                    class="file-input-hidden"
                    [accept]="field.accept || 'image/*'"
                    (change)="onFileSelect(field.key, $event)"
                  />
                </label>
              } @else {
                <div class="file-preview-container">
                  <img
                    [src]="getFilePreview(field.key)"
                    alt="Preview"
                    class="file-preview-image"
                  />
                  <button
                    type="button"
                    class="file-delete-btn"
                    (click)="onFileDeleteClick(field.key)"
                    aria-label="Eliminar imagen"
                  >
                    <i class="fas fa-trash-alt"></i>
                  </button>
                </div>
              }
            </div>
          }
          @case ('date') {
            <div [class.pointer-events-none]="field.editable === false"
                 [class.opacity-50]="field.editable === false"
                 [class.cursor-not-allowed]="field.editable === false">
              <p-datepicker
                [id]="field.key"
                [formControlName]="field.key"
                dateFormat="dd/mm/yy"
                [showIcon]="true"
                [showClear]="!field.required"
                [required]="field.required || false"
                [readonlyInput]="field.editable === false"
                placeholder="dd/mm/aaaa"
                styleClass="w-full"
                appendTo="body"
                [minDate]="field.minDate || undefined"
                [maxDate]="field.maxDate || undefined"
                [showOtherMonths]="false"
              />
            </div>
          }
          @case ('schedule') {
              <!-- <app-schedule-field-form
                [formControlName]="field.key"
                [required]="field.required || false"
                class="w-full"
              ></app-schedule-field-form>           -->
              <app-schedule-basic-field-form
                [formControlName]="field.key"
                [required]="field.required || false"
                class="w-full"
              ></app-schedule-basic-field-form>
          }
        }
        @if (field.maxLength) {
          <div class="w-full text-gray-500 text-sm text-right">{{ form.get(field.key)?.value?.length || 0 }}/{{ field.maxLength }}</div>
        }

        @if (form.get(field.key)?.invalid && form.get(field.key)?.touched) {
        <span class="text-red-500 text-sm">
          @if (form.get(field.key)?.hasError('required')) {
            Este campo es requerido
          } @else if (form.get(field.key)?.hasError('minlength')) {
            Este campo debe tener al menos {{ field.minLength }} caracteres
          } @else if (form.get(field.key)?.hasError('maxlength')) {
            Este campo debe tener como máximo {{ field.maxLength }} caracteres
          } @else if (form.get(field.key)?.hasError('maxDimensions')) {
            La imagen excede las dimensiones máximas permitidas ({{ field.maxDimensions }})
          } @else if (form.get(field.key)?.hasError('invalidExtension')) {
            No se permiten archivos con extensión .jfif
          } @else if (form.get(field.key)?.hasError('maxDigits')) {
            Este campo debe tener como máximo {{ field.maxLength }} dígitos
          } @else if (form.get(field.key)?.hasError('minDigits')) {
            Este campo debe tener al menos {{ field.minLength }} dígitos
          } @else if (form.get(field.key)?.hasError('max')) {
            <!-- number max value -->
            Este campo debe tener un valor máximo de {{ field.max }}
          } @else if (form.get(field.key)?.hasError('min')) {
            <!-- number min value -->
            Este campo debe tener un valor mínimo de {{ field.min }}
          }
        </span>
        }
      </div>
      }
      <!-- <div class="form-field">
        <label [for]="field.key">{{ field.label }}</label>
        <input
          [type]="field.type"
          [id]="field.key"
          [formControlName]="field.key"
          [required]="field.required || false"
        />
      </div> -->
    }
  </div>
  @if(showSubmitButton) {
  <div class="form-actions">
    @if (showDraftButton) {
      <button
        type="button"
        class="button button-draft"
        [disabled]="isLoading()"
        (click)="onSubmit(true)"
      >
        <span class="btn-text"><span>{{ draftButtonText }}</span></span>
      </button>
    }
    <button
      type="submit"
      class="button"
      [disabled]="isLoading() || (disableSubmitWhenPristine && form.pristine)"
    >
      @if (isLoading()) {
      <span class="btn-text"><span>Guardando...</span></span>
      } @else {
      <span class="btn-text"><span>{{ submitButtonText }}</span></span>
      }
    </button>
  </div>
}
</form>
